import { Button, Icon } from '@/shared/ui'

import styles from './withdrawal-funds.module.scss'

export const WithdrawalFunds = () => {
    return (
        <div className={styles['withdrawal-funds']}>
            <div className={styles['withdrawal-funds-amount']}>
                <span className={styles['withdrawal-funds-amount__title']}>Сколько</span>
                <div className={styles['withdrawal-funds-amount__editor']}>
                    <input
                        className={styles['withdrawal-funds-amount__editor--input']}
                        placeholder='0'
                        type='text'
                    />
                    <span className={styles['withdrawal-funds-amount__editor--currency']}>₽</span>
                    <Icon icon='xFill' size={24} />
                </div>
                <div className={styles['withdrawal-funds-amount__limits']}>
                    <span className={styles['withdrawal-funds-amount__limits--text']}>
                        от 50 до 1 529 ₽
                    </span>
                    <button className={styles['withdrawal-funds-amount__limits--button']}>
                        вывести всю сумму
                    </button>
                </div>
            </div>
            <div className={styles['withdrawal-funds-destination']}>
                <span className={styles['withdrawal-funds-destination__title']}>Куда</span>
                <div className={styles['withdrawal-funds-destination-input']}>
                    <div className={styles['withdrawal-funds-destination-input__card']}>
                        <span
                            className={styles['withdrawal-funds-destination-input__card--number']}
                        >
                            **** 2139
                        </span>
                        <span className={styles['withdrawal-funds-destination-input__card--type']}>
                            На карту
                        </span>
                    </div>
                    <Button
                        className={styles['withdrawal-funds-destination-input__button']}
                        size='small'
                        variant='secondary'
                    >
                        <Icon color='#0000009E' icon='chevron' size={20} />
                    </Button>
                </div>
            </div>
            <div className={styles['withdrawal-funds-commission']}>
                <span className={styles['withdrawal-funds-commission__text']}>
                    С выводимых денег удерживается
                    <br />
                    комиссия Jump.Taxi
                </span>
                <span className={styles['withdrawal-funds-commission__additional']}>
                    Подробнее можно узнать по почте
                    <br />
                    <a
                        className={styles['withdrawal-funds-commission__additional--link']}
                        href='mailto:supportb2b@jump.finance'
                    >
                        supportb2b@jump.finance
                    </a>
                </span>
            </div>
            <Button className={styles['withdrawal-funds__button']} size='large' variant='primary'>
                Запросить у партнёра
            </Button>
        </div>
    )
}
